const messages = {
  title: "Verkaufsförderung",
  desc: "Mit unseren Verkaufsförderungsaktionen für Bridgestone und Firestone unterstützen wir Sie aktiv im Verkaufsgespräch und geben Ihnen zusätzliche Argumente an die Hand. Wenn Sie Aktionen auch für Ihr Geschäft nutzen wollen, können Sie sich auf dieser Seite informieren und auch gleich Ihre Teilnahme als Handelspartner beantragen.",
  participation: {
    title: "Jetzt Teilnahme beantragen",
    desc: "Sie möchten eine oder mehrere unserer Aktionen in Ihrem Geschäft umsetzen? Dann können Sie hier Ihre Teilnahme beantragen. Ihr Betrieb wird für die Aktion(en) freigeschaltet und Sie erhalten innerhalb von 4 Wochen Aktionsmaterial für Ihren Verkaufstraum.<br/><br/>Treffen Sie Ihre Auswahl:",
    request: "TEILNAHME BEANTRAGEN",
    success: "Viele Dank, Ihre Anfrage wurde gesendet",
  },
  salesSupport: {
    title: "Verkaufsunterstützung",
    desc: "Wir bieten Ihnen verschiedene Massnahmen und Aktionen an, um Ihren Verkauf aktiv zu unterstützen - von der impulsstarken Verkaufsförderungsaktion über einen attraktiven Verkaufsraum bis hin zur individuellen Unterstützung.",
  },
  displaysFurniture: {
    title: "Displays & Möbel",
    desc: "Mit Ihren Prämienpunkten zu hochwertigen Ausstattungen für Ihren Verkaufsraum.",
  },
  salesPromotions: {
    title: "Verkaufsförderung",
    desc: "Attraktive Zugaben und Garantien für Ihre Kunden beim Reifenkauf.",
  },
};
export default {
  messages,
};
